import { QueryFilterParameter } from './../../widgets/filters/models/query-filter-parameter.model';
import { Injectable, inject } from '@angular/core';
import { BaseService, RequestOptions } from 'src/app/services/base.service';
import { Observable } from 'rxjs';
import { ForecastChartCaption } from 'src/app/models/forecast/fc-overview-models';
import { SelectStatementResult } from 'src/app/models/select-statement-result.model';

@Injectable({
	providedIn: 'root'
})
export class CapacityService {

	private static readonly REQUEST_TOP_PATH: string = "capacity";

	private _baseService: BaseService = inject(BaseService);

	getCapacityMatrix(filters: QueryFilterParameter[], periodType: string, primaryCapacityGroup: string)
		: Observable<SelectStatementResult> {
		let url = `capacity/GetCapacityMatrix?periodType=${periodType}&primaryCapacityGroup=${primaryCapacityGroup}`;

		return this._baseService.post(url, filters);
	}

	getOverviewTableData(
		action: string,
		filters: QueryFilterParameter[],
		columnName: string,
		periodType: string
	): Observable<CapacityOverviewTableData[]> {
		let url = `capacity/GetOverviewTableData?filters.action=${action || ''}&columnName=${columnName || ''}&periodType=${periodType || ''}`;

		return this._baseService.post(url, filters);
	}

	getOverviewGeneralTableData(
		filters: QueryFilterParameter[]
	): Observable<any> {
		let url = `capacity/GetOverviewGeneralTableData`;

		return this._baseService.post(url, filters);
	}

	getCapacityList(): Observable<CapacityList[]> {
		let url = `capacity/GetCapacityList`;
		return this._baseService.get(url);
	}

	getCapacityListNew(): Observable<ForecastChartCaption[]> {
		let url = `capacity/GetCaption`;
		return this._baseService.post(url);
	}

	getDeepDiveAutocompleteList(): Observable<string[]> {
		let url = `capacity/GetDeepDiveAutocompleteList`;
		return this._baseService.get(url);
	}

	getDeepDiveFullList(): Observable<CapacityDeepDiveEntity[]> {
		let url = `capacity/GetDeepDiveList`;
		return this._baseService.get(url);
	}

	public getCapacityInfoByProduct(productId: string, requestOptions?: RequestOptions): Observable<any> {
		const requestEndpoint: string = "GetCapacityInfoByProduct";

		let url = `${CapacityService.REQUEST_TOP_PATH}/${requestEndpoint}`;

		return this._baseService.post(
			url,
			{
				id: productId
			},
			requestOptions
		);
	}

	public getCapacityDeepDiveTreeListData(esoObjectId: string, requestOptions?: RequestOptions
		// inputLevels: number,
		// outputLevels: number
	): Observable<any> {
		const requestEndpoint: string = "GetCapacityDeepDiveTreeListData";

		let url = `${CapacityService.REQUEST_TOP_PATH}/${requestEndpoint}?esoObjectId=${esoObjectId}`; //&inputLevels=${inputLevels}&outputLevels=${outputLevels}`;

		return this._baseService.get(
			url,
			requestOptions
		);
	}
}

export class CapacityOverviewChartData {
	supplyTotalProductionTime: number;
	forecastTotalProductionTime: number;
	period: string;
}

export class CapacityOverviewTableData {
	supplyTotalProductionTime: number;
	forecastTotalProductionTime: number;
	capacityGroup: string;
	difference: number;
}

export class CapacityOverviewChartDto {
	captions: any[];
	data: CapacityOverviewChartData[];
}

export class CapacityTest {
	capacityGroup2: string;
	capacityClientCode: string;
	capacityGroup1: string;
	parentId: string;
}

export class CapacityList {
	listElement: string;
	caption: string;
}

export class CapacityDeepDiveEntity {
	productId: string;
	info: CapacityDeepDiveEntityFullInfo[];
}

export class CapacityDeepDiveEntityFullInfo {
	capacityGroup2: string;
	capacityClientCode: string;
	capacityGroup1: string;
	processUnitsPerHour: number;
	changeOverTimeHour: number;
}
